import { useState, useEffect, useContext } from "react";
import { notify } from "../utils/utils";
import { AuthFetch } from "../services/api";
import { useSpinner } from "./useSpinner";
// import { CalificacionesConductor } from "../app/pages/AtencionCliente/CalificacionConductores";


export const useCalificacionesRecargas = () => {
    const [ calificaciones, setCalificaciones ] = useState([]); // calificaciones Estrellas y opciones
    const [ calificacionesDetalle, setCalificacionesDetalle ] = useState([]); // calificaciones promedio de los conductores
    const [ spinner,mostrarSpinner,ocultarSpinner] = useSpinner();


    const listarCalificaciones = async () => {
        mostrarSpinner();
        const response = await AuthFetch('/Qualification/Recharge/average')
        !response.isValid && notify(response.exceptions[0].description,"error")
        setCalificaciones(response.isValid ? response.content : [])
        ocultarSpinner();
    }

    const listarCalificacionesDetalle = async (uid) => { //Listado detallado de las calificaciones de los conductores
        try{
            const response = await AuthFetch(`/Qualification/Recharge/detailed?` + new URLSearchParams({
                uid: uid
            }))
            !response.isValid && notify(response.exceptions[0].description,"error");
            setCalificacionesDetalle(response.isValid ? response.content : []);
        }
        catch(e){
            setCalificacionesDetalle([])
        }
    }

    return {listarCalificaciones,calificaciones,listarCalificacionesDetalle,calificacionesDetalle}

}